import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import { GET_ORGANIZATIONS_QUERY_KEY } from '@/state/queries/organizations/use-get-organizations.ts';

export const useDeleteOrganizationMutation = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string) => {
      const token = await getToken();
      return deleteOrganization(id, token ?? '');
    },
    onSuccess: () => {
      return queryClient.invalidateQueries({
        queryKey: [GET_ORGANIZATIONS_QUERY_KEY],
      });
    },
  });
};

const deleteOrganization = async (id: string, token: string) => {
  const url = `${import.meta.env.VITE_API_URL}/organizations/${id}`;
  return sendJSONRequest({ url, method: METHOD.DELETE, token });
};

export default useDeleteOrganizationMutation;
